import React from 'react';
import './styles.scss';

/**
 * @notice This is for a high level global styles
 * such as font/text stylings and some content
 * structuring.
 *
 * Each children should have their own "content"
 * class for specific content structing (ex.
 * widths, padding, etc.).
 */

function Layout({ children }) {
  return (
    <div className="javascript-layout">
      <div className="javascript-inner-layout">
        {children}
      </div>
    </div>
  );
}

export default Layout;
